<template>
<div class="chapter">
<div class="inner_page">
<section class="ident exergues" epub:type="epigraph" id="exergues">
<div class="exer" role="doc-epigraph">
<p class="txt_courant_ssalinea last retrait_autre"><i>He said, “We all got secrets. I got them same as everybody else—things we feel bad about and wish hadn’t ever happened. Hurtful things. Long ago things. We’re all scared and lonesome, but most of the time we keep it hid. It’s like every one of us has lost his way so bad we don’t even know which way is home any more only we’re ashamed to ask. You know what would happen if we would own up we’re lost and ask? Why, what would happen is we’d find out home is each other.”</i></p>
<p class="auteur">F<span class="small">REDERICK</span> B<span class="small">UECHNER</span></p>
<p class="sep" role="separator"><img alt="" role="presentation" src="Images/sep_autre.jpg"/></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ident12.vue?3b537175